module.exports = __webpack_public_path__ + "media/images/404-bg-c6fe29de4e977ceb19c1c2a63508ea8d.svg";